/* eslint-disable no-undef */
angular.module("vgresiduos").controller("vertownNotificationsManagerCtrl", [
	"$scope",
	"$rootScope",
	"$location",
	"accountService",
	"httpService",
	"vertownNotificationAccessService",
	"localStorageService",
	"userAccessService",
	"dialogService",
	"$state",
	"engagementScoreService",
	"featureAccessService",
	function (
		$scope,
		$rootScope,
		$location,
		accountService,
		httpService,
		vertownNotificationAccessService,
		localStorageService,
		userAccessService,
		dialogService,
		$state,
		engagementScoreService,
		featureAccessService
	) {
		"use strict";

		let hasPopupOpened = false;
		$scope.notifications = [];
		$scope.notificationAlerts = [];

		const onChangeLoggedClient = $rootScope.$on(Vgr.constants.evtChangeLoggedClient, function () {
			loadNotifications();
		});

		this.$onInit = function () {
			loadNotifications();
		};

		function loadNotifications() {
			if (!accountService.getCurrentClient()) {
				return;
			}

			buildDmrPopup();
			buildVertownNotifications();
		}

		function buildVertownNotifications() {
			httpService.getListFromServiceCore(vertownNotificationAccessService.listNotifications).then(function (response) {
				$scope.notifications = response.list;

				initializeNotificationPopups(response.list);
				initializeNotificationAlerts(response.list);
			});
		}

		// --- POPUS --- //
		function initializeNotificationPopups(notifications) {
			if (hasPopupOpened) {
				return;
			}

			const popups = notifications.filter((n) => n.typeId == Vgr.enumerations.vertownNotifications.types.popup);
			const foundPopup = popups.find((notification) => isNotificationAvailable(notification));
			if (foundPopup) {
				openPopup(foundPopup);
			}
		}

		function openPopup(notification) {
			hasPopupOpened = true;
			dialogService
				.showDialogFromTemplateV2(
					"views/components/vertownNotifications/vertownNotificationsPopup/vertownNotificationsPopup_template.html",
					"VertownNotificationsPopupCtrl",
					".vgr-page",
					{
						confirmDialog: dialogService.confirm,
						goToPageUrl: goToPageUrl,
						notificationName: notification.name,
						popupData: notification.popup
					},
					true
				)
				.then(
					function (updateLocalStorage) {
						hasPopupOpened = false;
						notification.alreadyShown = true;

						if (updateLocalStorage) {
							localStorageService.set(notification.localStorageKey, true);
						}
					},
					function () {
						hasPopupOpened = false;
						notification.alreadyShown = true;

						localStorageService.set(notification.localStorageKey, true);
					}
				);
		}

		/// --- ALERTS --- ///
		function initializeNotificationAlerts(notifications) {
			const alerts = notifications.filter((n) => n.typeId == Vgr.enumerations.vertownNotifications.types.alert);

			const pendingAlerts = alerts.filter((notification) => isNotificationAvailable(notification));
			$scope.notificationAlerts = pendingAlerts.map((notification) => {
				return {
					key: notification.localStorageKey,
					notificationName: notification.name,
					message: notification.alert.message,
					actionUrl: notification.alert.actionUrl,
					class: getAlertClass(notification.alert)
				};
			});
			$scope.$applyAsync();
		}

		$scope.closeAlert = function ($event, alert) {
			if ($event) {
				$event.stopPropagation();
			}

			trackEventAction(Vgr.trackings.vertownNotifications.close, alert.notificationName);
			if (alert.key) {
				localStorageService.set(alert.key, true);
			}

			$scope.notificationAlerts = $scope.notificationAlerts.filter((n) => n.key != alert.key);
			$scope.$applyAsync();
		};

		$scope.accessAlert = function (alert) {
			if (!alert.actionUrl) {
				return;
			}

			trackEventAction(Vgr.trackings.vertownNotifications.access, alert.notificationName);
			goToPageUrl(alert.actionUrl);
		};

		function getAlertClass(alert) {
			const classes = [];
			if (alert.actionUrl) {
				classes.push("cursor-pointer");
			}

			switch (alert.severityLevelId) {
				case Vgr.enumerations.vertownNotifications.severity.danger:
					classes.push("information-message-error-strong");
					break;
				case Vgr.enumerations.vertownNotifications.severity.warning:
					classes.push("information-message-warning");
					break;
				case Vgr.enumerations.vertownNotifications.severity.informative:
					classes.push("information-message-info");
					break;
			}

			return classes.join(" ");
		}

		/// --- DMR --- ///
		function buildDmrPopup() {
			if (hasPopupOpened) {
				return;
			}

			const dateMoment = moment();
			const hasDmrAccess = userAccessService.hasAccess(Vgr.systemPermissions.ViewDeclarations);
			const dmrKeyPrefix = "dmrAlertPopup_";
			const dmrAlertPopupKey = `${dmrKeyPrefix}${dateMoment.quarter()}_${dateMoment.year()}`;
			const disableDmrAlertPopup = localStorageService.get(dmrAlertPopupKey);
			if (
				!disableDmrAlertPopup &&
				isPeriodToShowDmrAlert(dateMoment) &&
				hasDmrAccess &&
				featureAccessService.hasResiduesManagementModule()
			) {
				openDmrPopup();
			}
		}

		function openDmrPopup() {
			hasPopupOpened = true;
			dialogService
				.showDialogFromTemplateV2(
					"views/components/vertownNotifications/dmrAlertPopup/dmrAlertPopup_template.html",
					"dmrAlertPopupCtrl",
					".vgr-page",
					{ alertPopupModel: null },
					true
				)
				.then(
					function () {
						hasPopupOpened = false;
						$state.go("dmrReport");
					},
					function () {
						hasPopupOpened = false;
					}
				);
		}

		function isPeriodToShowDmrAlert(dateMoment) {
			const dayOfMonth = dateMoment.date();
			const currentMonth = dateMoment.month() + 1;
			const monthsAlert = [1, 4, 7, 10]; // meses p/ alerta
			return monthsAlert.includes(currentMonth) && dayOfMonth >= 5;
		}

		/// --- COMMON --- ///

		function isNotificationAvailable(notification) {
			if (localStorageService.get(notification.localStorageKey) || notification.alreadyShown) {
				return false;
			}

			return !notification.pageUrl || isTargetUrlActive(notification.pageUrl);
		}

		function isTargetUrlActive(pageUrl) {
			const currentUrl = getCurrentDomain() + $state.current.url.split("?")[0];
			const targetUrl = getFullTargetUrl(pageUrl);

			return currentUrl === targetUrl;
		}

		function getFullTargetUrl(pageUrl) {
			return hasDomain(pageUrl) ? pageUrl : getCurrentDomain() + normalizeUrl(pageUrl);
		}

		function goToPageUrl(pageUrl) {
			if (!hasDomain(pageUrl) || pageUrl.startsWith(Vgr.constants.portalUrl)) {
				navigateTo(pageUrl);
				return;
			}

			window.open(pageUrl, "_blank");
		}

		const navigateTo = (url) => {
			const formattedUrl = getFormattedUrl(url);

			const [path, paramString] = formattedUrl.split("?");
			const queryObj = {};

			if (paramString) {
				paramString.split("&").forEach((param) => {
					const [key, value] = param.split("=");
					if (key) {
						queryObj[key] = value;
					}
				});
			}

			$location.path(`${normalizeUrl(path)}`).search(queryObj);
		};

		function getFormattedUrl(url) {
			return url.replace(Vgr.constants.portalUrl, "").replace(":id", accountService.getCurrentClient()?.id);
		}

		function hasDomain(pageUrl) {
			return pageUrl.startsWith("http://") || pageUrl.startsWith("https://");
		}

		function getCurrentDomain() {
			const protocol = $location.protocol();
			const host = $location.host();
			const port = $location.port();

			return host === "localhost" ? `${protocol}://${host}:${port}` : `${protocol}://${host}`;
		}

		function normalizeUrl(url) {
			return url.startsWith("/") ? url : "/" + url;
		}

		function trackEventAction(event, notificationName) {
			engagementScoreService.track(event, null, {
				Name: notificationName
			});
		}

		/// --- EVENTS --- ///

		const onLocationChangeSuccess = $scope.$on("$locationChangeSuccess", function () {
			if ($scope.notifications.length == 0) {
				onLocationChangeSuccess();
				return;
			}

			initializeNotificationPopups($scope.notifications);
			initializeNotificationAlerts($scope.notifications);
		});

		const onEvtPreviewAlertNotification = $rootScope.$on(
			Vgr.constants.evtPreviewAlertNotification,
			function (_evt, data) {
				$scope.notificationAlerts = [
					{
						message: data.message,
						actionUrl: data.actionUrl,
						class: getAlertClass(data)
					}
				];
				$scope.$applyAsync();
			}
		);

		this.$onDestroy = function () {
			// disable the listener
			onChangeLoggedClient();

			onEvtPreviewAlertNotification();

			onLocationChangeSuccess();

			// nullify the DOM-bound model
			$scope.domElement = null;
		};
	}
]);
